import FieldAffix from './FieldAffix.vue';
import FieldAutocomplete from './FieldAutocomplete.vue';
import FieldCategory from './FieldCategory.vue';
import FieldCheckbox from './FieldCheckbox.vue';
import FieldCheckboxList from './FieldCheckboxList.vue';
import FieldChoice from './FieldChoice.vue';
import FieldComponent from './FieldComponent.vue';
import FieldCondition from './FieldCondition.vue';
import FieldDateTime from './FieldDateTime.vue';
import FieldTime from './FieldTime.vue';
import FieldEditor from './FieldEditor.vue';
import FieldError from './FieldError.vue';
import FieldFilter from './FieldFilter.vue';
import FieldForm from './FieldForm.vue';
import FieldMinMax from './FieldMinMax.vue';
import FieldModule from './FieldModule.vue';
import FieldName from './FieldName.vue';
import FieldNumeric from './FieldNumeric.vue';
import FieldOptions from './FieldOptions.vue';
import FieldPeriod from './FieldPeriod.vue';
import FieldRadioList from './FieldRadioList.vue';
import FieldReadonly from './FieldReadonly.vue';
import FieldRequired from './FieldRequired.vue';
import FieldSelect from './FieldSelect.vue';
import FieldText from './FieldText.vue';
import FieldTextarea from './FieldTextarea.vue';
import FieldVisible from './FieldVisible.vue';
import FieldWithHelper from './FieldWithHelper.vue';
import FieldColumns from './FieldColumns.vue';
import FieldComputed from './FieldComputed.vue';
import FieldFilters from './FieldFilters.vue';
import FieldMap from './FieldMap.vue';
import FieldMapSelectInput from './FieldMapSelectInput.vue';
import FieldValidatorExpression from './FieldValidatorExpression.vue';
import FieldFormat from './FieldFormat.vue';
import FieldScript from './FieldScript.vue';
import FieldRelatedTitleTemplate from './FieldRelatedTitleTemplate.vue';
import FieldTrigger from './FieldTrigger.vue';

export {
    FieldAffix,
    FieldAutocomplete,
    FieldCategory,
    FieldCheckbox,
    FieldCheckboxList,
    FieldChoice,
    FieldComponent,
    FieldCondition,
    FieldDateTime,
    FieldEditor,
    FieldError,
    FieldFilter,
    FieldForm,
    FieldMinMax,
    FieldModule,
    FieldName,
    FieldNumeric,
    FieldOptions,
    FieldPeriod,
    FieldRadioList,
    FieldReadonly,
    FieldRequired,
    FieldSelect,
    FieldText,
    FieldTextarea,
    FieldVisible,
    FieldWithHelper,
    FieldColumns,
    FieldComputed,
    FieldFilters,
    FieldMap,
    FieldMapSelectInput,
    FieldValidatorExpression,
    FieldFormat,
    FieldScript,
    FieldRelatedTitleTemplate,
    FieldTrigger
};

export default {
    'field-affix': FieldAffix,
    'field-autocomplete': FieldAutocomplete,
    'field-category': FieldCategory,
    'field-checkbox': FieldCheckbox,
    'field-checkboxlist': FieldCheckboxList,
    'field-choice': FieldChoice,
    'field-component': FieldComponent,
    'field-condition': FieldCondition,
    'field-datetime': FieldDateTime,
    'field-time': FieldTime,
    'field-editor': FieldEditor,
    'field-filter': FieldFilter,
    'field-form': FieldForm,
    'field-error': FieldError,
    'field-minmax': FieldMinMax,
    'field-module': FieldModule,
    'field-name': FieldName,
    'field-numeric': FieldNumeric,
    'field-options': FieldOptions,
    'field-period': FieldPeriod,
    'field-radiolist': FieldRadioList,
    'field-readonly': FieldReadonly,
    'field-required': FieldRequired,
    'field-select': FieldSelect,
    'field-text': FieldText,
    'field-textarea': FieldTextarea,
    'field-visible': FieldVisible,
    'field-with-helper': FieldWithHelper,
    'field-columns': FieldColumns,
    'field-computed': FieldComputed,
    'field-filters': FieldFilters,
    'field-map': FieldMap,
    'field-map-select-input': FieldMapSelectInput,
    'field-validator-expression': FieldValidatorExpression,
    'field-format': FieldFormat,
    'field-script': FieldScript,
    'field-related-title-template': FieldRelatedTitleTemplate,
    'field-trigger': FieldTrigger
};
